import React from "react";

const ScrollSentinel = React.forwardRef((props, ref) => {
  return <div ref={ref} data-feedback-sentinel className="h-1" />;
});

ScrollSentinel.displayName = "ScrollSentinel";

export default ScrollSentinel;
